import { defineSemanticTokens } from '@chakra-ui/react'

export const colors = defineSemanticTokens.colors({
  light: {
    solid: { value: { _light: '{colors.light.50}', _dark: '{colors.light.900}' } },
    contrast: { value: { _light: '{colors.gray.700}', _dark: '{colors.light.100}' } },
    fg: { value: { _light: '{colors.gray.600}', _dark: '{colors.light.300}' } },
    muted: { value: { _light: '{colors.light.300}', _dark: '{colors.light.800}' } },
    subtle: { value: { _light: '{colors.light.100}', _dark: '{colors.light.900}' } },
    emphasized: { value: { _light: '{colors.light.400}', _dark: '{colors.light.700}' } },
    focusRing: { value: { _light: '{colors.light.500}', _dark: '{colors.light.500}' } },
    border: { value: { _light: '{colors.light.400}', _dark: '{colors.light.700}' } },
  },
  gray: {
    solid: { value: { _light: '{colors.gray.200}', _dark: '{colors.gray.600}' } },
    contrast: { value: { _light: '{colors.gray.700}', _dark: '{colors.gray.200}' } },
  },
  gray50: {
    value: {
      _light: '{colors.gray.50}',
      _dark: '{colors.gray.800}',
    },
  },
  gray100: {
    value: {
      _light: '{colors.gray.100}',
      _dark: '{colors.gray.700}',
    },
  },
})
